import React from "react";

export function Menu({ children, className }) {
  return <menu className={className}>{children}</menu>;
}
